import React, { useRef, useEffect, PropsWithChildren } from "react";

import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { OptionsType } from "@fancyapps/ui/types/Fancybox/options";
import ButtonPlane from "../../UI/Button/ButtonPlane";

interface Props {
  caption: string;
  images: Array<{ image: string; id: number }>;
  videos: Array<string>;
  options?: Partial<OptionsType>;
  delegate?: string;
}
const SeeBeforeAfterButton = ({
  images,
  videos,
  caption,
  children,
  delegate,
  options
}: PropsWithChildren<Props>) => {
  const containerRef = useRef(null);

  const openGallery = () => {
    NativeFancybox.show(
      [
        ...images.map((img) => ({
          src: img.image,
          type: "image" as const,
          caption
        })),
        ...videos.map((vid) => ({
          src: vid,
          type: "youtube" as const,
          caption
        }))
      ],
      {
        Carousel: { infinite: true, transition: "slide", Autoplay: true },
        Toolbar: { absolute: false },
        Thumbs: { type: "classic" }
      }
    );
  };

  useEffect(() => {
    const container = containerRef.current;

    const fancyBoxDelegate = delegate || "[data-fancybox]";
    const fancyBoxOptions = options || {};

    NativeFancybox.bind(container, fancyBoxDelegate, fancyBoxOptions);

    return () => {
      NativeFancybox.unbind(container);
      NativeFancybox.close();
    };
  }, []);

  return (
    <div ref={containerRef}>
      {children}
      <div className="service_before_after_wrapper">
        <ButtonPlane
          onClick={openGallery}
          className="service_before_after_btn"
          size="sm"
        >
          See Before & After
        </ButtonPlane>
      </div>
    </div>
  );
};

export default SeeBeforeAfterButton;
